export default __webpack_public_path__ + "static/media/05_liska_info-min.b48fa538.jpg";